import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { api, eventCard, go } from './util';

/** A place's tag page: its next three events (a country's page includes its cities'). Hidden when there are none. */
const cache = {};
export default class TagEvents extends Component {
  view(vnode) {
    const slug = vnode.attrs.slug;
    if (!(slug in cache)) {
      cache[slug] = null;
      app.request({
        method: 'GET',
        url: api() + '?limit=3&place=' + encodeURIComponent(slug),
        errorHandler: () => {}
      }).then(r => cache[slug] = r && r.events || []).catch(() => cache[slug] = []).then(() => m.redraw());
    }
    const list = cache[slug];
    if (!list || !list.length) return null;
    return m("section", {
      className: "VEvt-box VEvt-tag"
    }, m("div", {
      className: "VEvt-tagHead"
    }, m("h3", null, m("i", {
      className: "far fa-calendar",
      "aria-hidden": "true"
    }), " Upcoming events"), m("a", {
      href: "/events",
      onclick: go('/events')
    }, "All events \u2192")), m("div", {
      className: "VEvt-tagList"
    }, list.map(e => eventCard(e))));
  }
}
flarum.reg.add('voucha-community', 'forum/events/TagEvents', TagEvents);